import { Col, Row } from "react-bootstrap";
import { useStore } from "../../context/AppContext";
import { fDateCustom } from "../../libs/formats";
import UploadedFilesChart from "./charts/uploadedFiles";
import InstanceChart from "./charts/Intances";
import ZoneCharts from "./charts/ZoneCharts";
import TypeCharts from "./charts/TypeCharts";

export default function Dashboard(){
    const { state } = useStore();
    return(
        <div className="flex-fill" style={{height: "100%"}}>
            <div className="d-flex flex-column-reverse flex-md-row justify-content-md-between mb-4">
                <div className="">
                    <h4>Bienvenido {state.user.credentials?.fullname}</h4>
                </div>
                <div>
                    <h4>{fDateCustom(new Date().toDateString(), "PPPP")}</h4>
                </div>
            </div>
            <div>
                <Row>
                    <Col xs={12} md={6}>
                        <UploadedFilesChart />
                    </Col>
                    <Col xs={12} md={6}>
                        <InstanceChart />
                    </Col>
                </Row>
                <ZoneCharts />
                <TypeCharts />
            </div>
        </div>
    )
}